interface AuthorInfoType {
  name: string;
  role: string;
  avatar?: string;
  date: string;
}

interface AuthorInfoPropsType {
  author: AuthorInfoType;
  className?: string;
}

const AuthorInfo = ({ author, className = '' }: AuthorInfoPropsType) => {
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <div className="size-12 shrink-0 overflow-hidden rounded-full bg-gray-200">
        <img
          src={author.avatar}
          alt={author.name}
          width={48}
          height={48}
          className="size-full object-cover object-center"
          loading="lazy"
        />
      </div>
      <div className="flex-1">
        <div className="mb-0.5 text-base font-semibold text-gray-800">
          {author.name}
        </div>
        <div className="text-xs text-gray-500">{author.role}</div>
      </div>
      <div className="ml-auto text-sm text-gray-500">{author.date}</div>
    </div>
  );
};

export default AuthorInfo;
